/*
 * @Author: yuqiuyu 18180464352@163.com
 * @Date: 2022-06-27 15:33:47
 * @LastEditors: yuqiuyu 18180464352@163.com
 * @LastEditTime: 2022-07-05 17:14:32
 * @FilePath: \vueproject-master\src\store\modules\header.js
 * @Description:
 *
 * Copyright (c) 2022 by 斯马特有限公司, All Rights Reserved.
 */
const state = {
  searchInfo: "",
  searchInfo_BBS: ""
};

const mutations = {
  ADD_SEARCHINFO: (state, searchInfo) => {
    console.log(searchInfo, "搜索字段");
    state.searchInfo = searchInfo;
  },
  ADD_SEARCHINFO_BBS: (state, searchInfo_BBS) => {
    state.searchInfo_BBS = searchInfo_BBS;
  }
};

export default {
  namespaced: true,
  state,
  mutations
  // actions
};



// WEBPACK FOOTER //
// ./src/store/modules/header.js